import React, { memo, forwardRef } from "react";
const SvgRightHalfOpenInterval = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M5.187 26.74h-2.7c-.702 0-1.053-.351-1.053-1.053V5.817c0-.702.351-1.053 1.053-1.053h2.7c.54 0 .81.243.81.729s-.27.729-.81.729h-1.97v19.06h1.97c.54 0 .81.243.81.729s-.27.729-.81.729zM17.17 21.097l-1.54 4.698c-.161.468-.44.702-.836.702a.935.935 0 01-.648-.243.72.72 0 01-.27-.594c0-.144.027-.306.08-.486l1.432-4.617c.144-.522.45-.783.918-.783.27 0 .495.081.675.243.18.162.27.378.27.648 0 .09-.027.234-.081.432zM29.603 10.569c.648 2.016.972 3.077.972 5.183s-.324 3.176-.972 5.21c-.648 2.016-1.503 3.78-2.565 5.292-.216.306-.468.459-.756.459a.808.808 0 01-.594-.243.722.722 0 01-.243-.567c0-.18.072-.387.216-.621.954-1.476 1.71-3.132 2.268-4.968.576-1.836.864-2.69.864-4.562 0-1.872-.288-2.726-.864-4.562-.558-1.836-1.314-3.492-2.268-4.968-.144-.234-.216-.441-.216-.621 0-.234.081-.423.243-.567a.808.808 0 01.594-.243c.288 0 .54.153.756.459 1.062 1.512 1.917 3.285 2.565 5.319z"
      />
    </svg>
  );
});
SvgRightHalfOpenInterval.displayName = "SvgRightHalfOpenInterval";
const MemoForwardRef = memo(SvgRightHalfOpenInterval);
export default MemoForwardRef;
